import React from "react";
import Head from "next/head";
import { descriptionDefault, keywordDefault } from "./data";
import { ISeo } from "@/types/ui.types";
export const SeoHead: React.FC<ISeo> = ({
  isIndex = false,
  title,
  description = descriptionDefault,
  keywords = keywordDefault,
  children
}) => {
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="index.tsx">
        <title>{title}</title>
        <meta name="description" content={description} data-sentry-element="meta" data-sentry-source-file="index.tsx" />
        <meta name="keywords" content={keywords} data-sentry-element="meta" data-sentry-source-file="index.tsx" />
        {isIndex && <>
            <meta name="robots" content="noindex,nofollow,noarchive" />
            <meta name="googlebot" content="noindex,nofollow,noarchive" />
          </>}
        <meta name="viewport" content="width=device-width, initial-scale=1" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
        {children}
      </Head>
    </>;
};